import WorkerAvatar from "./WorkerAvatar";
import {
  WORKER_AVATAR_DEFAULT_DESIGN,
  type WorkerAvatarDesign,
} from "@/utils/workerAvatarDicebear";

/** Agentic v2 agent avatar — seed gradient + Waves overlay (same as Workers module / Chat). */
export default function AgentWorkerAvatar({
  name,
  size = 28,
  className,
  design = WORKER_AVATAR_DEFAULT_DESIGN,
}: {
  name: string;
  /** @deprecated Display colours are derived from `name` only, matching Workers module. */
  avatarColour?: string | null;
  size?: number;
  className?: string;
  design?: WorkerAvatarDesign;
}) {
  return (
    <WorkerAvatar
      seed={name}
      size={size}
      className={className}
      design={design}
    />
  );
}
